import type { CreateSurveyParams } from 'app/common/types/surveys'
import type { Request } from '../../../index'
import { convertParams as convertCreateParams } from '../post'

export type SurveyOverlap = {
  survey_id: number
  survey_title: string
  period: string
  schools_count: number
}
export type SurveyOverlapResult = { has_overlaps: boolean; overlaps: Array<SurveyOverlap> }
export const convertParams = (params: CreateSurveyParams) => {
  const [body] = convertCreateParams(params)
  const { title, survey_kind, survey_location, ...scope } = body
  return [scope, undefined] as [Record<string, unknown>, void]
}
export const CHECK_SURVEY_OVERLAP: Request<CreateSurveyParams, SurveyOverlapResult, void> = [
  'food/surveys/check_overlap',
  'post',
  ['data'],
]
